import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  ImageLoadFailed: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: "120px",
    padding: "12px",
    textAlign: "center",
    fontSize: "14px",
    color: "rgba(255, 255, 255, 0.85)",
  },
});

/** Shown in place of a lesion image whose load failed, so the clinician is not left with a spinner. */
export default function ImageLoadFailed() {
  const styles = useStyles();
  return (
    <div className={styles.ImageLoadFailed}>
      Could not load this image. Reload the page to try again.
    </div>
  );
}
